import { Color } from '@billy/design-system'

import { Variant } from '../types/variant'

export const variantStyles: Record<Variant, Color> = {
  error: Color.Red700,
  neutral: Color.Grey200,
  primary: Color.Lavender400,
  success: Color.Green400,
  warning: Color.Yellow400,
}
